import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { UserRoles } from "../../enums/userRoles";
import { RegularButton } from "colbi_web_ui/lib/components/inputs";
import styles from "./SeriesButton.module.sass";

const SeriesButton = (props) => {
    const { i18n, params, reload, pushModal, user } = useGlobalValue();
    const validateUser = [
        UserRoles.ADMIN,
        UserRoles.OWNER,
        UserRoles.READER,
        UserRoles.WRITER,
        UserRoles.BACKOFFICE,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ].includes(user.role);
    const { projectModules } = props;
    const { modules } = projectModules || {};
    return (
        <>
            {validateUser &&
            params &&
            params.section === "activity" &&
            modules &&
            modules.includes("delete_series") ? (
                <div className={styles["container"]}>
                    <>
                        <RegularButton
                            primary
                            onClick={() => {
                                pushModal({
                                    title: i18n`Series Configuration`,
                                    args: {
                                        projectId: params.projectId,
                                        section: params.section,
                                        locale: params.locale,
                                    },
                                    view: "SeriesForm",
                                })
                                    .then(() => reload && reload())
                                    .catch(() => null);
                            }}
                            data-toggle={"tooltip"}
                            data-placement={"top"}
                        >
                            {i18n`Series Configuration`}
                        </RegularButton>
                    </>
                </div>
            ) : (
                <div />
            )}
        </>
    );
};

export default SeriesButton;
